import React, { useState, useRef, useEffect } from 'react';

import image from '../../assets/Images/LoginImage.png';
import SoilDoctorLogo from '../../assets/Images/SoilDoctorLogo.png'

import 'bootstrap/dist/css/bootstrap.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Formik, Field } from 'formik';
import Select from 'react-select';
import { FaSpinner } from 'react-icons/fa';
import { State, City } from 'country-state-city';
import { usePincodeLookup } from '../../hooks/usePincodeLookup';
import { Spinner } from 'react-bootstrap';
import * as Yup from 'yup';
import AlertBox from '../../components/common/AlertBox';
import axiosInstance from '../../utils/axios';

function generateClassName(errors, touched, fieldName) {
  const hasError = errors[fieldName] && touched[fieldName];
  const isSuccess = touched[fieldName];
  return `form-control ${hasError
    ? 'border-2 border-danger'
    : isSuccess
      ? 'border-2 border-success'
      : ''
    }`;
}

// for form validation
const schema = Yup.object({
  companyName: Yup.string().required('Company name is required'),
  primaryPersonName: Yup.string().required('Primary person name is required'),
  primaryPersonMobile: Yup.string()
    .required('Primary person mobile is required')
    .min(10, 'Invalid Mobile number')
    .max(10, 'Invalid Mobile number'),
  primaryPersonEmail: Yup.string()
    .email('Invalid email address')
    .required('Primary person email is required'),
  secondaryPersonName: Yup.string(),
  secondaryPersonMobile: Yup.string()
    .min(10, 'Invalid Mobile number')
    .max(10, 'Invalid Mobile number'),
  secondaryPersonEmail: Yup.string().email('Invalid email address'),
  address: Yup.string().required('Address is required'),
  pincode: Yup.string()
    .required('Pincode is required')
    .min(6, 'Invalid Pincode')
    .max(6, 'Invalid Pincode'),
  state: Yup.string().required('State is required'),
  city: Yup.string().required('City is required'),
});

function Register() {
  const citySelectRef = useRef(null);
  const [stateCode, setStateCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const { pincodeData, loading: pincodeLoading, lookupPincode, reset: resetPincode } = usePincodeLookup();
  const [alertProps, setAlertProps] = useState({
    alertHeading: '',
    alertContent: '',
    variant: '',
  });

  const formApiRef = useRef({});

  const updatedStates = () =>
    State.getStatesOfCountry('IN').map((state) => ({
      key: state.id,
      label: state.name,
      value: state.id,
      ...state,
    }));

  const updatedCities = (stateId, pincodeDistrict) => {
    if (!stateId) return [];
    const cities = City.getCitiesOfState('IN', stateId).map((city) => ({
      label: city.name,
      value: city.name,
      name: city.name,
      ...city,
    }));
    if (pincodeDistrict && !cities.some((c) => c.name === pincodeDistrict)) {
      cities.unshift({
        label: pincodeDistrict,
        value: pincodeDistrict,
        name: pincodeDistrict,
      });
    }
    return cities;
  };

  useEffect(() => {
    if (!pincodeData || !formApiRef.current.setFieldValue) return;
    const { setFieldValue, setStateCode } = formApiRef.current;
    const states = State.getStatesOfCountry('IN');
    const matchedState = states.find((s) => s.name === pincodeData.state);
    if (matchedState) {
      setFieldValue('state', matchedState.name);
      setStateCode(matchedState.isoCode);
    }
    setFieldValue('city', pincodeData.district);
    if (formApiRef.current.citySelectRef?.current) {
      formApiRef.current.citySelectRef.current.clearValue();
    }
  }, [pincodeData]);

  return (
    <Formik
      initialValues={{
        companyName: '',
        primaryPersonName: '',
        primaryPersonMobile: '',
        primaryPersonEmail: '',
        secondaryPersonName: '',
        secondaryPersonMobile: '',
        secondaryPersonEmail: '',
        address: '',
        pincode: '',
        city: '',
        state: '',
      }}
      validationSchema={schema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setIsLoading(true);
        axiosInstance
          .post('/Inquiry', {
            entity_name: values.companyName,
            primary_person_name: values.primaryPersonName,
            primary_person_mobile_no: values.primaryPersonMobile,
            primary_person_email_id: values.primaryPersonEmail,
            secondary_person_name: values.secondaryPersonName,
            secondary_person_mobile_no: values.secondaryPersonMobile,
            secondary_person_email_id: values.secondaryPersonEmail,
            business_address: values.address,
            pincode: values.pincode,
            city: values.city,
            state: values.state,
            source: 'partner',
          })
          .then(({ data }) => {
            setIsLoading(false);
            setSubmitting(false);
            console.log('RESPONSE: ', data);
            if (data.inquiry_id) {
              console.log('Inquiry created successfully!');
              setShowAlert(true);
              setAlertProps({
                alertHeading: 'Inquiry raised',
                alertContent:
                  'Your application for becoming partner has been submitted successfully!',
                variant: 'success',
              });
              resetForm();
            }
          })
          .catch((error) => {
            setIsLoading(false);
            setShowAlert(true);
            setAlertProps({
              alertHeading: 'Something Went Wrong.',
              alertContent:
                'Sorry, your application could not submit. Please try again!',
              variant: 'danger',
            });
            console.log('ERROR: ', error);
          });
      }}
    >
      {({
        isSubmitting,
        values,
        handleChange,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        errors,
        touched,
      }) => {
        formApiRef.current = {
          setFieldValue,
          setStateCode,
          citySelectRef,
          values,
        };
        return (
        <div
          className={`login-container m-0  ${window.innerWidth <= 768 ? 'py-4' : 'py-0'
            }`}
        >
          {/* Left content */}
          <div className='login-left'>
            <div className='logo'>
              <img src={SoilDoctorLogo} alt='Logo' width='250px' />
            </div>
            <div className='left-content'>
              <h1 className='fw-bolder mb-3'>Welcome to Soil Doctor! </h1>
              <img src={image} alt='Background' className='responsive-image' />
              <figure className='w-75'>
                <blockquote className='blockquote'>
                  <h3>
                    To forget how to dig the earth and to tend the soil is to
                    forget ourselves.
                  </h3>
                </blockquote>
                <figcaption className='blockquote-footer'>
                  <cite title='Source Title'>Mohandas K. Gandhi</cite>
                </figcaption>
              </figure>
            </div>
          </div>
          {/* Right content */}
          <div className='login-right'>
            <div className='login-form' contentEditable={false}>
              <Form
                className='form__details'
                onSubmit={handleSubmit}
                onChange={handleChange}
              >
                <h3 className='pt-4 pb-0'>Partner Enabling Form</h3>
                <Row className='my-4'>
                  {/* company name */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='text'
                        name='companyName'
                        value={values.companyName}
                        placeholder='Company Name'
                        className={generateClassName(
                          errors,
                          touched,
                          'companyName'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='companyName'>
                        Company Name{' '}
                        <span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {errors.companyName && touched.companyName ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.companyName}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* primary person name */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='text'
                        name='primaryPersonName'
                        value={values.primaryPersonName}
                        placeholder='Primary Person Name'
                        className={generateClassName(
                          errors,
                          touched,
                          'primaryPersonName'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='primaryPersonName'>
                        Primary Person Name{' '}
                        <span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {errors.primaryPersonName && touched.primaryPersonName ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.primaryPersonName}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* primary person mobile */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='number'
                        name='primaryPersonMobile'
                        value={values.primaryPersonMobile}
                        placeholder='Enter Mobile Number'
                        className='form-control border-2 border-success'
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='primaryPersonMobile'>
                        Primary Person Mobile
                        <span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {errors.primaryPersonMobile &&
                      touched.primaryPersonMobile ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.primaryPersonMobile}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* primary person email */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='email'
                        name='primaryPersonEmail'
                        value={values.primaryPersonEmail}
                        placeholder='Enter Email'
                        className={generateClassName(
                          errors,
                          touched,
                          'primaryPersonEmail'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='primaryPersonEmail'>
                        Primary Person Email
                        <span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {errors.primaryPersonEmail && touched.primaryPersonEmail ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.primaryPersonEmail}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* secondary person name */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='text'
                        name='secondaryPersonName'
                        value={values.secondaryPersonName}
                        placeholder='Secondary Person Name'
                        className={generateClassName(
                          errors,
                          touched,
                          'secondaryPersonName'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='secondaryPersonName'>
                        Secondary Person Name
                        <span className='text-danger'>&nbsp;</span>
                      </Form.Label>
                    </div>
                    {errors.secondaryPersonName &&
                      touched.secondaryPersonName ? (
                      <div className='form_errors'>
                        &#9888; {errors.secondaryPersonName}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* secondary person mobile */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='number'
                        name='secondaryPersonMobile'
                        value={values.secondaryPersonMobile}
                        placeholder='Enter Address'
                        className={generateClassName(
                          errors,
                          touched,
                          'secondaryPersonMobile'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='secondaryPersonMobile'>
                        Secondary Person Mobile{' '}
                        <span className='text-danger'>&nbsp;</span>
                      </Form.Label>
                    </div>
                    {errors.secondaryPersonMobile &&
                      touched.secondaryPersonMobile ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.secondaryPersonMobile}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* secondary person email */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='email'
                        name='secondaryPersonEmail'
                        value={values.secondaryPersonEmail}
                        placeholder='Enter Address'
                        className={generateClassName(
                          errors,
                          touched,
                          'secondaryPersonEmail'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='secondaryPersonMobile'>
                        Secondary Person Email{' '}
                        <span className='text-danger'>&nbsp;</span>
                      </Form.Label>
                    </div>
                    {errors.secondaryPersonEmail &&
                      touched.secondaryPersonEmail ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.secondaryPersonEmail}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* address */}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='text'
                        name='address'
                        value={values.address}
                        placeholder='Enter Email'
                        className={generateClassName(
                          errors,
                          touched,
                          'address'
                        )}
                        onChange={handleChange}
                      />
                      <Form.Label htmlFor='address'>
                        Address<span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {errors.address && touched.address ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.address}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* pincode*/}
                  <Form.Group as={Col} md='6' className='group'>
                    <div className='form-floating'>
                      <Field
                        type='number'
                        name='pincode'
                        value={values.pincode}
                        placeholder='Enter Pincode'
                        className={generateClassName(
                          errors,
                          touched,
                          'pincode'
                        )}
                        onChange={(e) => {
                          handleChange(e);
                          if (String(e.target.value).length !== 6) resetPincode();
                        }}
                        onBlur={(e) => {
                          setFieldTouched('pincode', true);
                          if (String(e.target.value).trim().length === 6) {
                            lookupPincode(e.target.value);
                          }
                        }}
                      />
                      <Form.Label htmlFor='pincode'>
                        Pincode<span className='text-danger'>&nbsp;*</span>
                      </Form.Label>
                    </div>
                    {pincodeLoading && (
                      <small className='text-muted'>Looking up address...</small>
                    )}
                    {errors.pincode && touched.pincode ? (
                      <div className='form_errors'>
                        {' '}
                        &#9888; {errors.pincode}
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* Address suggestion from pincode */}
                  {pincodeData?.addressSuggestions?.length > 0 && (
                    <Form.Group as={Col} md='12' className='group'>
                      <Form.Label>Suggested addresses (select to auto-fill)</Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder='Select address suggestion'
                        options={pincodeData.addressSuggestions}
                        onChange={(opt) => {
                          if (opt) setFieldValue('address', opt.value);
                        }}
                      />
                    </Form.Group>
                  )}

                  {/* state */}
                  <Form.Group as={Col} md='6' className='group'>
                    <Select
                      id='state'
                      name='state'
                      className={`custom-dropdown ${generateClassName(
                        errors,
                        touched,
                        'state'
                      )}`}
                      value={
                        values.state
                          ? updatedStates().find((s) => s.name === values.state) || {
                              label: values.state,
                              value: values.state,
                              name: values.state,
                            }
                          : null
                      }
                      isSearchable={true}
                      placeholder='Select State'
                      options={updatedStates()}
                      onChange={(value) => {
                        if (!value) return;
                        values.state = value.name;
                        setFieldValue('state', value.name);
                        setStateCode(value.isoCode);
                        setFieldValue('city', '');
                        citySelectRef.current?.clearValue();
                      }}
                      onBlur={() => setFieldTouched('state', true)}
                    />
                    {errors.state && touched.state ? (
                      <div className='form_errors'> &#9888; {errors.state}</div>
                    ) : null}
                  </Form.Group>

                  {/* city */}
                  <Form.Group as={Col} md='6' className='group'>
                    <Select
                      id='city'
                      name='city'
                      className={`custom-dropdown ${generateClassName(
                        errors,
                        touched,
                        'city'
                      )}`}
                      ref={citySelectRef}
                      isSearchable={true}
                      placeholder='Select City'
                      options={updatedCities(
                        values.state && stateCode ? stateCode : null,
                        pincodeData?.district
                      )}
                      value={
                        values.city
                          ? { label: values.city, value: values.city }
                          : null
                      }
                      onChange={(value) => {
                        const cityVal = value?.name ?? value?.value ?? '';
                        setFieldValue('city', cityVal);
                        values.city = cityVal;
                      }}
                      onBlur={() => setFieldTouched('city', true)}
                    />
                    {errors.city && touched.city ? (
                      <div className='form_errors'> &#9888; {errors.city}</div>
                    ) : null}
                  </Form.Group>
                </Row>

                <div className='my-3 col col-md-6 mx-auto'>
                  {/* Submit button */}
                  <button
                    type='submit'
                    className='w-100 text-center btn btn-dark'
                    disabled={isSubmitting}
                  >
                    {isLoading && (
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                    )}
                    <span>Submit</span>
                  </button>
                </div>
              </Form>
            </div>
          </div>

          {showAlert && (
            <AlertBox
              show={showAlert}
              setShow={setShowAlert}
              alertProps={alertProps}
            />
          )}

          {isLoading && (
            <div className='loading-overlay'>
              <FaSpinner className='loading-icon spin' />
            </div>
          )}
        </div>
      );
      }}
    </Formik>
  );
}

export default Register;
